import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { MenuButton, MenuItem } from "@headlessui/react";
import { useTable, usePagination, Row, TableInstance } from 'react-table'

import DropDown from './DropDown'
import { SortableList } from "../dnd/SortableList";
import { COOKIE_KEYS } from "../../utils/Constants";
import { persistedPageSize, readFromCookie } from "../../utils/Helpers";
import { PageSizeSelector } from "./PageSizeSelector";

type ReactTableProps<T extends object> = {
    columns: any[];
    manifest: T[];
    loading?: boolean;
    meta?: any;
    links?: any;
    showPageSize?: boolean;



    pageHandler?: (perPage: number) => void;
    navigation?: (url: string) => void;
    input?: any;
    visibleColumns?: any;
    toggleColumn?: any;
    display?: any;
    reorderfunc?: any;
    interstitial_zone?: any;
};

export default function ReactTable<T extends object>({ columns, manifest, loading, pageHandler, meta, links, navigation, showPageSize = true, input = null, visibleColumns = null, toggleColumn = undefined, display = null, reorderfunc = undefined, interstitial_zone = null }: ReactTableProps<T>) {
    const [state, setstate] = useState({
        goToPage: null,
    })

    // const [pageSize, setPageSize] = useState(() => {
    //     const cookieValue = readFromCookie(COOKIE_KEYS.PAGE_COUNT);
    //     const parsed = Number(cookieValue);
    //     return Number.isFinite(parsed) && parsed > 0 ? parsed : 25;
    // });

    const [pageSize, setPageSize] = useState(() =>
        persistedPageSize()
    );

    const displayColumns = display;
    const skeletonRows = Math.min(pageSize, 10)

    const {
        page,
        prepareRow,
        headerGroups,
        getTableProps,
        getTableBodyProps,
    } = useTable<T>(
        {
            columns,
            data: manifest,
            initialState: {
                pageSize,
                pageIndex: 0,
            },
        },
        usePagination
    ) as TableInstance<T> & { page: Row<T>[] };

    const onChangeHandler = (e: any) => {
        if (loading) return

        setstate((prevState) => ({
            ...prevState,
            goToPage: e.target.value
        }));
    }

    const onInputBlur = (e: any) => {
        if (loading) return
        const goToValue = isNaN(e.target.value) ? 1 : Math.min(Math.max(e.target.value, 1), meta.lastPage);

        setstate((prevState) => ({
            ...prevState,
            goToPage: goToValue
        }));
    }

    const goToPageHandler = (e: any) => {
        e.preventDefault()
        if (loading) return

        let { goToPage } = state
        const lastPageRoute = meta.lastPageUrl

        if (!goToPage) return
        if (isNaN(goToPage)) return

        const [basePath, query] = lastPageRoute.split("?");
        const searchParams = new URLSearchParams(query);

        const currentPage = searchParams.get("page");
        if (currentPage === goToPage) return

        searchParams.set("page", goToPage);
        const finalGoToPageRoute = `${basePath}?${searchParams.toString()}`;

        navigation(finalGoToPageRoute)
    }

    const handlePageSizeChange = (newPageSize: number) => {
        // 1. persistedPageSize checks if 50 != current cookie (25)
        // 2. It writes '50' to the cookie
        // 3. It returns 50
        const validatedSize = persistedPageSize(newPageSize);

        // 4. state is updated to match the new cookie
        setPageSize(validatedSize);
    };

    return (
        <React.Fragment>
            <div className="w-full flex flex-col md:flex-row gap-3 md:items-center align-middle lg:px-2 bg-slate-100 py-1.5">
                <div className="flex-1 flex flex-row-reverse align-middle items-center">
                    <div className="md:w-72 lg:flex-1">
                        {/* <InputBasic
                            name={"name"}
                            required={true}
                            label={"Section Title"}
                            posting={posting}
                            value={state.input.name}
                            error={state.errors.name}
                            blurHandler={onInputBlur}
                            changeHandler={onChangeHandler}
                        /> */}

                        {/* <input type="text" placeholder={"Search Bar"} autoComplete="off"
                            className={clsx(
                                'text-slate-800 ring-slate-300 dark:ring-slate-600 placeholder:text-slate-400 dark:placeholder:text-slate-400 focus:border-0 focus:ring-orange-500 focus:outline-orange-500 border border-slate-300 dark:border-slate-600 dark:placeholder-slate-400 dark:text-white dark:ocus:ring-orange-500 dark:focus:outline-orange-500 ',
                                'text-sm border sm:text-sm rounded-md block w-full py-1.5 px-2 dark:bg-slate-800 disabled:cursor-not-allowed h-10'
                            )} /> */}
                    </div>

                    {
                        showPageSize && (
                            <PageSizeSelector
                                pageSize={pageSize}
                                setPageSize={handlePageSizeChange}
                                actionHandler={pageHandler}
                            />
                        )
                    }
                </div>

                <div className="flex-1 flex flex-row-reverse">
                    <div className="flex-none">
                        <DropDown
                            type="custom"
                            button={
                                <>
                                    <MenuButton className="relative w-auto md:min-w-24 flex align-middle items-center gap-x-3 md:px-3 px-1.5 py-1 text-sm text-slate-600 dark:text-slate-400 border border-slate-300 dark:border-slate-400 rounded-lg bg-white dark:bg-slate-900 hover:bg-white dark:hover:bg-slate-900/30 focus:bg-white dark:focus:bg-slate-900/50 focus:outline-none focus:ring-0 focus:ring-slate-500/50 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 ease-in-out md:h-auto h-10">
                                        <span className="fa-light fa-bars-filter"></span>

                                        <span className="text-sm md:block hidden">
                                            Filters
                                        </span>
                                    </MenuButton>
                                </>
                            }
                            items={
                                <div className="text-sm w-56 md:h-72 flex flex-col p-1.5">
                                    <div className="flex-grow overflow-auto">
                                        <SortableList
                                            items={displayColumns}
                                            onChange={(newDisplayList) => reorderfunc(newDisplayList)}
                                            renderItem={(displayColumn: any) => {
                                                const finalColumn = displayColumn.key === 'z'
                                                if (finalColumn) return

                                                const columnDiv = (
                                                    <div key={`disp-col-${displayColumn.id}`} className="flex-1 flex align-middle items-center gap-x-3 py-2">
                                                        <button type="button" onClick={displayColumn.default ? undefined : () => toggleColumn(displayColumn)} disabled={displayColumn.default} className="flex-1 bg-inherit hover:bg-inherit flex space-x-3 accent-orange-600 align-middle items-center disabled:cursor-not-allowed disabled:text-slate-400 dark:disabled:text-slate-700">
                                                            {
                                                                visibleColumns.includes(displayColumn.key) ? (
                                                                    <span className="fa-solid fa-square-check fa-xl text-orange-600 disabled:cursor-not-allowed disabled:text-gray-400 dark:disabled:text-slate-700" aria-disabled={displayColumn.default}></span>
                                                                ) : (
                                                                    <span className="fa-light fa-square fa-xl text-slate-500 dark:text-slate-400"></span>
                                                                )
                                                            }

                                                            <span aria-disabled={displayColumn.default} className="w-full cursor-pointer text-base text-start disabled:cursor-not-allowed disabled:text-gray-500 dark:disabled:text-slate-700">
                                                                {displayColumn.label}
                                                            </span>
                                                        </button>
                                                    </div>
                                                )

                                                if (displayColumn.default) {
                                                    return columnDiv
                                                } else if (!finalColumn) {
                                                    return (
                                                        <SortableList.Item id={displayColumn.id}>
                                                            {columnDiv}

                                                            <SortableList.DragHandle />
                                                        </SortableList.Item>
                                                    )
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>

            <div className="w-full relative transition-colors">
                {
                    loading ? (
                        <div className="bg-inherit flex items-enter justify-center">
                            <table className="w-full divide-y divide-slate-200 dark:divide-slate-600 text-sm mt-4">
                                <thead>
                                    <tr key={`--sktln-thead`}>
                                        {
                                            columns.map((column: any, index: any) => {
                                                const isVisible = visibleColumns.includes(column.key);

                                                return (
                                                    <th key={`--sktln-thead-col-${index}`} className={`px-3 py-3.5 bg-slate-200 dark:bg-slate-900 text-left text-sm text-slate-400 dark:text-slate-200 tracking-wider `}>
                                                        <div className="h-5 bg-gray-300 dark:bg-slate-700 rounded w-full"></div>
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>

                                <tbody className="animate-pulse">
                                    {
                                        Array.from({ length: skeletonRows }).map((_, index) => (
                                            <tr key={`--sktln-tbody-row-${index}`} className="w-full border-b border-slate-300 dark:border-slate-600">
                                                {
                                                    columns.map((_, index) => (
                                                        <td key={`--sktln-thead-col-${index}`} className={`px-3 py-3 text-left text-sm text-slate-400 dark:text-slate-200 tracking-wider `}>
                                                            <div className={`h-4 ${index % 2 === 0 ? 'bg-gray-200 dark:bg-slate-900' : 'bg-gray-300 dark:bg-slate-700'} rounded w-full`}></div>
                                                        </td>
                                                    ))
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <table {...getTableProps()} className="w-full divide-y text-sm divide-slate-300 dark:divide-slate-600 table-auto mt-2">
                            <thead>
                                {
                                    headerGroups.map((headerGroup: any, indexKey: number) => (
                                        <tr {...headerGroup.getHeaderGroupProps()} key={`thead-tr-${indexKey}`}>
                                            {
                                                visibleColumns.map((visibleKey: any, index: number) => {
                                                    const column = headerGroup.headers.find((col: any) => col.key === visibleKey);
                                                    if (!column) return null;

                                                    const { key, ...restProps } = column.getHeaderProps();
                                                    const totalColumns = headerGroups[0].headers.length

                                                    return (
                                                        <th {...column.getHeaderProps()} key={key} className={clsx(
                                                            totalColumns > 3 && index > 2 && index !== (totalColumns - 1) ? "md:hidden lg:table-cell" : "",
                                                            "px-3 py-2 text-left text-sm text-slate-600 uppercase dark:text-slate-200 tracking-wider font-medium"
                                                        )}>
                                                            {column.render("Header")}
                                                        </th>
                                                    );
                                                })
                                            }
                                        </tr>
                                    ))
                                }
                            </thead>

                            <tbody {...getTableBodyProps()}>
                                {
                                    manifest.length > 0 ? (
                                        page.map((row, index) => {
                                            prepareRow(row);

                                            return (
                                                <tr {...row.getRowProps()} key={`tbody-tr-${index}`} className="group transition-colors border-b border-slate-300 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 w-full">
                                                    {
                                                        visibleColumns.map((visibleKey: any, index: number) => {
                                                            const cell = row.cells.find((c: any) => c.column.id === visibleKey || c.column.key === visibleKey);
                                                            if (!cell) return null;

                                                            const totalColumns = page[0].allCells.length
                                                            const { key, ...restProps } = cell.getCellProps();

                                                            return (
                                                                <td {...cell.getCellProps()} key={key} className={`px-3 py-1.5 whitespace-nowrap ${totalColumns > 3 && index > 2 && index !== (totalColumns - 1) ? `md:hidden lg:table-cell` : ``} align-middle`}>
                                                                    {cell.render("Cell")}
                                                                </td>
                                                            );
                                                        })
                                                    }
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="group transition-colors border-b border-slate-300 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 w-full">
                                            <td colSpan={visibleColumns.length} className="px-3 py-2 whitespace-nowrap">
                                                <div className="flex flex-col items-center justify-center w-full text-slate-500 dark:text-slate-400">
                                                    <span className="block text-sm">
                                                        No entries to display.
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    )
                }
            </div>

            {/* "Interstitial" literally means "situated between." 
            * It is the perfect technical term for a section that lives 
            * between two established blocks (the Body and the Results)
            */}
            {interstitial_zone}

            <div className="pagination mt-6">
                <div className="w-full flex md:flex-row pb-3 flex-col align-middle md:items-center">
                    <div className="flex-1">
                        {
                            showPageSize && manifest.length >= 50 && (
                                <PageSizeSelector
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    actionHandler={pageHandler}
                                />
                            )
                        }
                    </div>

                    <div className="flex-1 md:pb-0">
                        {
                            !loading ? (
                                <p className="text-sm md:text-center text-slate-500 dark:text-slate-400">
                                    Showing {meta.from} - {meta.to} of {meta.total} results
                                </p>
                            ) : null
                        }
                    </div>

                    <div className="flex-1 md:py-0 flex md:flex-row-reverse">
                        {
                            meta.lastPage > 10 && (
                                <form onSubmit={goToPageHandler} className="flex align-middle items-center space-x-2">
                                    <label htmlFor="goto-page" className="text-slate-800 dark:text-slate-200 text-sm">
                                        Go to page:
                                    </label>

                                    <div className="flex items-center w-20">
                                        <input type="text" id="goto" className="w-10 h-8 pl-1.5 text-sm text-slate-700 dark:text-slate-300 border border-r-0 rounded-r-none border-slate-300 dark:border-slate-600 focus:border-slate- focus:outline-none rounded shadow-sm dark:bg-inherit" onChange={onChangeHandler} onBlur={onInputBlur} value={state.goToPage ?? ''} autoComplete='off' />

                                        <button type="submit" disabled={loading} className="h-8 px-2 text-sm bg-orange-500 dark:bg-orange-600 border border-l-0 border-orange-500 dark:border-orange-600 rounded-r shadow-sm text-orange-50 hover:text-white disabled:bg-orange-400 hover:bg-orange-600 dark:hover:bg-orange-700 hover:border-orange-600 focus:outline-none flex align-middle items-center justify-center">
                                            <i className="fad fa-arrow-right fa-lg"></i>
                                        </button>
                                    </div>
                                </form>
                            )
                        }
                    </div>
                </div>

                <div className="py-3 px-3 flex flex-col sm:flex-row-reverse items-center justify-between">
                    <nav className="flex space-x-2.5 rounded-md text-slate-600 text-sm" aria-label="Pagination">
                        {
                            links.map((paginate: any, index: any) => {
                                // Check if the URL is not null or undefined
                                const hasUrl = !!paginate.url;

                                // Determine the label to render
                                let displayLabel = paginate.label
                                    .replace('Previous', '')
                                    .replace('Next', '')
                                    .trim();

                                // Adjust size with text-lg
                                displayLabel = displayLabel.replace(/(&laquo;|&raquo;)/g, (match) => {
                                    return `<span className="text-lg">${match}</span>`;
                                });

                                return (
                                    <button
                                        type="button"
                                        disabled={!hasUrl}
                                        key={`link-bit-x${index}`}
                                        onClick={hasUrl ? () => navigation(paginate.url) : undefined}
                                        className={clsx(
                                            paginate.active
                                                ? 'bg-orange-100 dark:bg-orange-600/60 border-orange-500 dark:border-orange-600/80 text-orange-600 dark:text-orange-200'
                                                : 'bg-white dark:bg-inherit border-slate-300 dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 disabled:hover:bg-inherit',
                                            'w-8 h-8 border text-sm rounded disabled:text-slate-400 dark:disabled:text-slate-500 dark:text-slate-400',
                                            hasUrl ? 'cursor-pointer' : 'cursor-not-allowed'
                                        )}
                                        dangerouslySetInnerHTML={{ __html: displayLabel }}
                                    />
                                );
                            })
                        }
                    </nav>
                </div>
            </div>
        </React.Fragment>
    )
}
